















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop, PropSync } from 'vue-property-decorator';
import Directory from '@/modules/contacts/directory/components/Directory.vue';
import * as FORM_INTERFACE from '../interfaces/accessTicket.interface';
import * as rules from '@/modules/shared/shared/domain/rules';
import { CustomerContact } from '@/modules/contacts/shared/domain/customer-contact';
import { ContactsGetters } from '@/modules/contacts/shared/store/contacts.getters';
import { contacts } from '@/modules/shared/shared/store/namespaces';
import PhoneField from '@/modules/shared/shared/components/PhoneField.vue';

@Component({
    components: {
        PhoneField,
        Directory,
    },
})
export default class AuthorizedPerson extends Vue {
    @Prop()
    isFormComplete!: number;

    modalCheck: boolean = true;

    @PropSync('oldItem', {
        default: function() {
            return {
                firstName: '',
                lastName: '',
                telephoneNumber: '',
                idNumber: '',
            };
        },
    })
    authorizedPerson!: FORM_INTERFACE.authorizedPeopleInterface;

    @PropSync('selectedValues', {
        default: function() {
            return Array();
        },
    })
    selectedValuesProp!: number[];

    id: number | undefined = undefined;

    rules: any = rules;

    searchContactInDirectory(contactId: number) {
        return this.customerContacts.filter(item => item.id === contactId);
    }

    getContactSelected(contact: { id: number }) {
        let values: {
            newId: number;
            oldId: number | undefined;
        } = {
            newId: contact.id,
            oldId: this.id,
        };
        this.$emit('authorizedPersonSelected', values);
        this.id = contact.id;

        const contactSelected = this.searchContactInDirectory(contact.id)[0];

        (this.authorizedPerson.contactId = contactSelected.id),
            (this.authorizedPerson.firstName = contactSelected.name),
            (this.authorizedPerson.lastName = contactSelected.lastName),
            (this.authorizedPerson.idNumber = contactSelected.ci),
            (this.authorizedPerson.telephoneNumber = contactSelected.phone);
    }

    @Watch('isFormComplete')
    sendData(value: boolean, oldValue: boolean) {
        this.$emit('receiveAuthorizedPerson', this.authorizedPerson);
    }

    @contacts.Getter(ContactsGetters.GET_DIRECTORY)
    customerContacts!: CustomerContact[];
}
